<div [class]="style" (shClickOutside)="setDropdownClosed()">
    <sh-droppanel-select
        [id]="id"
        [multiple]="multiple"
        [options]="options$ | async"
        [initialSelectedValues]="initialSelectedValues$ | async"
        [sortAlphabetically]="sortAlphabetically"
        [itemCapCount]="itemCapCount"
        [listCappedMsg]="listCappedMsg"
        [search]="search"
        [searchPlaceholderMsg]="searchPlaceholderMsg"
        [autocompleteFct]="autocompleteFct"
        [noResultsActionItem]="noResultsActionItem"
        [noResultsFoundMsg]="noResultsFoundMsg"
        [isOpen$]="isOpen$"
        [openDirection]="openDirection"
        [droppanelStyle]="droppanelStyle"
        [height]="height"
        [limitHeightToViewport]="limitHeightToViewport"
        [inOverflownContainer]="inOverflownContainer"
        [loading$]="loading$"
        [loadingMsg]="loadingMsg"
        [allowSingleDeselect]="allowSingleDeselect"
        (selectionState)="onSelectionStateChange($event)"
        (searchTerm)="onSearch($event)"
        (shownItemCount)="onShownItemCountChange($event)"
    >
        <button
            [id]="id"
            type="button"
            class="sh-icon-button sh-form-group__input sh-form-multiselect__select"
            (click)="toggleDropdown()"
            [attr.disabled]="disabled ? true : null"
            [title]="title$ | async"
        >
            <span class="sh-form-multiselect__select__label" [class.sh-wrap-text]="wrapLabel">{{ selectLabel$ | async }}</span>
            <svg sh-icon class="sh-icon-button__icon--end push-right" [name]="'angle-down'" [size]="sizes.SMALL" aria-hidden="true"></svg>
        </button>
    </sh-droppanel-select>
</div>
